"use client";

import { useRouter } from "next/navigation";

import { CheckboxFacet } from "./checkbox-facet";
import type { FacetCount } from "./types";
import { buildItemSearchUrl, type ItemSearchParams } from "@/lib/item-search-params";

export function BrandFacet({ facets, params }: { facets: FacetCount[]; params: ItemSearchParams }) {
  const router = useRouter();

  return (
    <CheckboxFacet
      title="Brand"
      facets={facets}
      selected={params.brand}
      onChange={(next) => router.push(buildItemSearchUrl(params, { brand: next }))}
    />
  );
}
